import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface IProps {
  id?: string;
  contractId?: string;
  contracts?: string;
  status?: string;
  responseId?: string;
  paymentStatus?: "paid" | "cleared";
  identifier?: string;
  sort?: string;
}

export async function GetPaymentNotice({
  id,
  contractId,
  contracts,
  status,
  responseId,
  paymentStatus,
  identifier,
  sort,
}: IProps) {
  let url = `${endpoints.ADMFHIR}/PaymentNotice`;
  if (id) url = `${url}/${id}`;
  if (contractId) url = `${url}?request=Contract/${contractId}`;
  if (responseId) url = `${url}?response=Contract/${responseId}`;
  if (contracts) url = `${url}?request=${contracts}`;
  if (status) url = `${url}&status=${status}`;
  if (paymentStatus) url = `${url}?payment-status=${paymentStatus}`;
  if (identifier) url = `${url}&identifier=${identifier}`;
  if (sort) url = `${url}&_sort=${sort}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetPaymentNotice: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetPaymentNotice ", error);
      // toast.error(`GetPaymentNotice Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
